import { Component, Inject, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule, JkDialogEditComponent, jkRestReturn } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from "jk-advcom";
import { MtrmbService,  } from '../_service_mtr';
import { Mtrmb } from '../_entity_mtr';


@Component({
  selector: 'app-mtrmb-edit',
  templateUrl: './mtrmb-editPkg.component.html',
  styleUrls: [],
  standalone: true,
  imports: [JackBaseComponentModule, AdvComModule,MaterialModule],
})

export class MtrmbEditComponent extends JkDialogEditComponent<MtrmbService,Mtrmb>{
  override srv!: MtrmbService;
  constructor(
    inject: Injector,
    public override dialogRef: MatDialogRef<MtrmbEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    super(inject,dialogRef,data);
  }


}
